import { Dispatch } from 'react';
import { GridData, GridState } from 'components/common/grid/';

export const applyGridData = (
    data: { rows: GridData; results: number },
    dispatch: Dispatch<Partial<GridState>>,
): void => {
    dispatch({
        gridData: data.rows,
        totalCount: data.results,
        dataLoadingDone: true,
        gridReorderLoading: false,
    });
};
